function bandStyles(band?: string | null) {
  switch (band) {
    case "GREEN":
      return {
        label: "On Target",
        dot: "bg-emerald-500",
        shell: "bg-emerald-50 text-emerald-700 border-emerald-200",
      }
    case "AMBER":
      return {
        label: "At Risk",
        dot: "bg-amber-500",
        shell: "bg-amber-50 text-amber-700 border-amber-200",
      }
    case "RED":
      return {
        label: "Behind Target",
        dot: "bg-red-500",
        shell: "bg-red-50 text-red-700 border-red-200",
      }
    default:
      return {
        label: "No Target",
        dot: "bg-slate-400",
        shell: "bg-slate-100 text-slate-600 border-slate-200",
      }
  }
}

export function PerformanceBandBadge({
  band,
  compact = false,
}: {
  band?: string | null
  compact?: boolean
}) {
  const styles = bandStyles(band)

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-xs font-semibold ${styles.shell}`}
    >
      <span className={`h-2 w-2 rounded-full ${styles.dot}`} aria-hidden="true" />
      <span>{compact ? band ?? "UNSET" : styles.label}</span>
    </span>
  )
}
